import { Component, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValuesAccessorBase } from '../custom-control/ValueAccesorBase';

@Component({
  selector: 'app-text-box-currency',
  templateUrl: './text-box-currency.component.html',
  styleUrls: ['./text-box-currency.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TextBoxCurrencyComponent,
    multi: true
  }]
})
export class TextBoxCurrencyComponent extends ValuesAccessorBase<string> implements OnInit {

  @Input() label: string;
  @Input() obrigatorio: Boolean;
  @Input() placeholder: '';
  @Input() name: string;
  @Input() maxLength: Number;

  ngOnInit(): void {
  }

}
